import React from 'react'
import Loader from 'react-loader-spinner'
import colors from '../../branding/colors'

export default function OnfsLoading({
  size = 80,
  style = { textAlign: 'center' },
  ...rest
}) {
  return (
    <Loader
      type='ThreeDots'
      color={colors.primary}
      height={size}
      width={size}
      style={style}
      rest
    />
  )
}
